import {
  AccordionWrapper,
  AccordionToggle,
  AccordionTitle,
  AccordionChevron,
  AccordionContent,
} from './mobile-accordion-section.styles';

const MobileAccordionSection = ({ title, children, isOpen, onToggle }) => {
  return (
    <AccordionWrapper>
      <AccordionToggle onClick={onToggle}>
        <AccordionTitle>{title}</AccordionTitle>
        <AccordionChevron isOpen={isOpen}>▾</AccordionChevron>
      </AccordionToggle>
      <AccordionContent isOpen={isOpen}>{children}</AccordionContent>
    </AccordionWrapper>
  );
};

export default MobileAccordionSection;
